<template>
  <div class="row">
  	<div class="card col-12" style="width: 18rem;">
	  	<div class="card-body my-5 ">
	  		<div v-bind:class="loading">
		      <div class="d-flex justify-content-center">
		        <div class="spinner-border m-5" role="status">
		          <span class="sr-only">Loading...</span>
		        </div>
		      </div>
		    </div>
		    <div v-bind:class="result">
		  		<div class="row justify-content-center">
					<form class="col-md-6 text-center" autocomplete="off" v-on:submit.prevent="Reimprimir">
					  <h5 class="card-title">Reimprimir Hoja de Registro</h5>
					  <div class="form-group mt-4">
					    <label for="idsolicitud">Folio de Registro</label>
					    <input type="text" v-model="idsolicitud" class="form-control w-50 mx-auto text-center" id="idsolicitud" />
						</div>
            <h6>ó</h6>
            <div class="form-group mt-4">
              <label for="no_ceneval">Folio Ceneval</label>
              <input type="text" v-model="no_ceneval" class="form-control w-50 mx-auto text-center" id="no_ceneval" />
            </div>
					    <button type="submit" class="btn btn-primary mt-4">Imprimir</button>
					</form>
		  		</div>
		  	</div>
	  	</div>
	</div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      loading:'d-none',
      result:'',
      idsolicitud:"",
      no_ceneval:"",
    }
  },
  methods:{
  	Validar(){
  		var pasar = true;
  		if (this.idsolicitud.length==0 && this.no_ceneval.length==0) {
  			pasar=false;
  			swal("Datos incompletos","Debes colocar algun folio", "error");
  		}
  		return pasar;
  	},
  	Reimprimir(){
  		if (!this.Validar()) {return;}
  		this.Cargando();
		this.$router.push({name:'Imprimir_Registro',params:{
		  	idsolicitud:this.idsolicitud,
        no_ceneval:this.no_ceneval
		}});
  	},
  	Cargando(){
  		this.loading='';
  		this.result='d-none';
  	},
  	Listo(){
  		this.loading='d-none';
  		this.result='';
  	}
  },
  created(){
    localStorage.apikeySiepsBiologicasUanl=JSON.stringify("eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJzaWVwc191YW5sX3Bvc2dyYWRvIiwiZGF0YSI6eyJpZHNvbGljaXR1ZCI6IjEiLCJpZGFsdW1ubyI6IjEifSwiaWF0IjoxNzE4ODM2MTM2LCJleHAiOjIwMzQzNjg5MzZ9.duBO5wP9M2_ttUAxXwcAIeIoxw0zom2Nlr0qX4RM7yg");
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Reimprimir_Registro.vue